import { Component } from '@angular/core';
import { membersuiteChangeMemoLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Change Memo Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitechangememolineitem-form',
    templateUrl: './membersuitechangememolineitem.form.component.html'
})
export class membersuiteChangeMemoLineItemFormComponent extends BaseFormComponent {
    public record!: membersuiteChangeMemoLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

